import { render } from "./ProporsionOfFailedVsFinishedChart.vue?vue&type=template&id=090b147b"
import script from "./ProporsionOfFailedVsFinishedChart.vue?vue&type=script&lang=js"
export * from "./ProporsionOfFailedVsFinishedChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__